export const getOwnerUsers = (allOwners, projectUsers) => {
    return allOwners
      .filter(owner => !owner.IsGroup)
      .map(owner => {
        const user = projectUsers.find(u => u.Id === owner.Id);
        return user ? { ...user, IsOwner: true } : null;
      })
      .filter(Boolean);
  };
  
export const getOwnerGroups = (allOwners, projectGroups) => {
    return allOwners
      .filter(owner => owner.IsGroup)
      .map(owner => {
        const group = projectGroups.find(g => g.GroupId === owner.Id);
        return group ? { ...group, IsOwner: true } : null;
      })
      .filter(Boolean);
  };
  
export const getUniqueGroups = (groups) => {
    return Array.from(new Map(groups.map(g => [g.GroupId, g])).values());
  };
  
export const sortByName = (list) => {
    return list.sort((a, b) =>
      (a.User?.Name || a.Name || "").localeCompare(b.User?.Name || b.Name || "")
    );
  };
  